<template>
  <div
    :class="[
      border ? 'border' : '',
      'page-heading flex space-between align-center'
    ]"
  >
    <div class="flex align-center">
      <span
        v-if="back"
        @click="goBack"
        class="go-back mdi mdi-24px mdi-chevron-left cursor-pointer"
      ></span>
      <Heading :heading="title" />
    </div>
    <div class="right-aligned-items">
      <slot name="content" />
    </div>
  </div>
</template>

<script>
import Heading from "./Heading";
export default {
  components: {
    Heading
  },
  props: {
    title: {
      type: String,
      default: ""
    },
    back: {
      type: Boolean,
      default: false
    },
    border: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    goBack() {
      return this.$router.go(-1);
    }
  }
};
</script>

<style scoped>
.page-heading {
  padding: 1rem;
}
.custom-select .vs__selected-options input {
  width: 200px;
}
.border {
  border-bottom: 1px solid var(--line);
}
.go-back:before {
  font-size: 24px !important;
  margin-top: 3px;
  margin-right: 8px;
  color: var(--muted);
}
</style>
